import { useEffect } from "react";
import { Link } from "react-router-dom";
import { oktaSignOut } from "./oktaSignOut";
import "../components/Login/Login.less";

export function LogoutPage() {
  useEffect(() => {
    oktaSignOut();
  }, []);

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <p className="subtitle">Signing you out…</p>
        </div>
        <div className="text-center" style={{ padding: "1rem" }}>
          <i className="fa fa-spinner fa-spin" style={{ fontSize: "2rem" }} />
          <p style={{ marginTop: "1rem" }}>
            <Link to="/login">Return to login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
